import * as React from "react";
import { memo } from "react";
const SvgModalCloseButtonBg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M30.476 30.578 0 32 .762 0 32 .711l-1.524 29.867Z", fill: "#ED254E" }));
const Memo = memo(SvgModalCloseButtonBg);
export default Memo;
